import { render, staticRenderFns } from "./rolesList.vue?vue&type=template&id=02d966a2&scoped=true"
import script from "./rolesList.vue?vue&type=script&lang=js"
export * from "./rolesList.vue?vue&type=script&lang=js"
import style0 from "./rolesList.vue?vue&type=style&index=0&id=02d966a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d966a2",
  null
  
)

export default component.exports